import { render, staticRenderFns } from "./questionnaireStatistics.vue?vue&type=template&id=00bbe6b8&scoped=true"
import script from "./questionnaireStatistics.vue?vue&type=script&lang=js"
export * from "./questionnaireStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bbe6b8",
  null
  
)

export default component.exports